const landing = {
    hero: {
        title: 'Prenota esperienze uniche in Abruzzo',
        subtitle: 'Scopri la bellezza del gioiello nascosto d\'Italia',
        cta: 'INIZIA ORA'
    },
    trips: {
        title: 'I Nostri Viaggi',
        subtitle: 'Esplora le nostre esperienze curate',
        summerTrip: {
            title: 'Avventura Estiva',
            description: 'Vivi il meglio dell\'Abruzzo in estate',
            price: 'Da €299'
        },
        winterTrip: {
            title: 'Paesaggio Invernale',
            description: 'Scopri la magia invernale dell\'Abruzzo',
            price: 'Da €399'
        }
    },

    tripStatus: {
        comingSoon: 'Il viaggio sarà presto disponibile, rimani sintonizzato ❤️'
    },
    destinations: {
        title: 'Destinazioni Popolari',
        subtitle: 'Luoghi da non perdere in Abruzzo',
        roccaCalascio: {
            title: 'Rocca Calascio',
            description: 'Il borgo delle nuvole'
        },
        collaltoSabino: {
            title: 'Collalto Sabino',
            description: 'Il borgo medievale della Sabina'
        },
        santoStefanoDiSessanio: {
            title: 'Santo Stefano di Sessanio',
            description: 'Il gioiello medievale del Gran Sasso'
        },
        trabocchiCoast: {
            title: 'Costa dei Trabocchi',
            description: 'La costa incantata dei trabocchi'
        },
        campoImperatore: {
            title: 'Campo Imperatore',
            description: 'Il Piccolo Tibet d\'Abruzzo'
        },
        scanno: {
            title: 'Scanno',
            description: 'Il Borgo dei Gioielli e del Lago'
        }
    },
    activities: {
        title: 'Sfoglia Attività',
        subtitle: 'L\'avventura ti aspetta in Abruzzo', deerWatching: {
            title: 'Wild Life Spotting',
            description: 'Scopri la fauna selvatica nel parco nazionale'
        },
        wineTasting: {
            title: 'Degustazione Vini',
            description: 'Assapora vini locali e prodotti tipici'
        },
        arrosticiniMucciante: {
            title: 'Arrosticini Mucciante',
            description: 'La tradizione culinaria abruzzese'
        },
        sextantio: {
            title: 'Sextantio',
            description: 'L\'albergo diffuso del borgo'
        }
    },
    curiosities: {
        title: 'Curiosità',
        subtitle: 'Scopri i segreti dell\'Abruzzo',
        wildlife: {
            title: 'Wildlife',
            description: 'La fauna selvatica dell\'Abruzzo'
        },
        gastronomy: {
            title: 'Gastronomia',
            description: 'I sapori autentici dell\'Abruzzo'
        },
        history: {
            title: 'Storia'
        }
    },
    products: {
        title: 'I Nostri Prodotti',
        subtitle: 'Scopri i sapori autentici dell\'Abruzzo con la nostra selezione di prodotti tipici',
        viewAll: 'Vedi Tutti i Prodotti',
        moreComingSoon: 'Altri prodotti arriveranno presto'
    },
    footer: {
        about: 'Chi Siamo',
        contact: 'Contatti',
        privacy: 'Privacy',
        terms: 'Termini e Condizioni',
        companyDescription: 'Esperienze uniche in Abruzzo. Scopri la bellezza della natura, dei borghi e della cultura italiana.',
        quickLinks: 'Link Rapidi',
        followUs: 'Seguici',
        followUsDescription: 'Resta aggiornato sulle nostre ultime esperienze e offerte speciali.',
        copyright: '© 2025 La Dolce Vita Reis. Tutti i diritti riservati.',
        cookiePolicy: 'Cookie Policy',
        manageCookies: 'Gestisci Cookie',
        creativeCommons: 'Immagini con licenza Creative Commons — ',
        fullCredits: 'crediti completi qui.'
    },
    cookieBanner: {
        title: '🍪 Utilizziamo i cookie',
        description: 'Utilizziamo i cookie principalmente per analisi e per migliorare la tua esperienza. I cookie di sistema vengono automaticamente accettati. Accettando, acconsenti all\'utilizzo di questi cookie. Puoi gestire le tue preferenze o saperne di più sulla nostra politica sui cookie.',
        privacyPolicy: 'Informativa sulla Privacy',
        termsAndConditions: 'Termini e Condizioni',
        acceptAll: 'Accetta Tutto',
        rejectAll: 'Rifiuta Tutto',
        managePreferences: 'Gestisci Preferenze'
    },
    cookieModal: {
        title: '🍪 Gestisci le Preferenze sui Cookie',
        necessaryCookies: 'Cookie Necessari',
        alwaysActive: 'Sempre Attivi',
        necessaryDescription: 'Questi cookie sono essenziali per il funzionamento del sito web e non possono essere disattivati.',
        analyticsCookies: 'Cookie Analytics',
        analyticsDescription: 'Questi cookie ci aiutano a migliorare il sito analizzando come viene utilizzato.',
        moreInfo: 'Puoi modificare le tue preferenze in qualsiasi momento. Per maggiori informazioni, consulta la nostra',
        cookiePolicy: 'Informativa sui Cookie',
        savePreferences: 'Salva Preferenze',
        acceptAll: 'Accetta Tutti',
        rejectAll: 'Rifiuta Tutti',
        cancel: 'Annulla'
    }
};

export default landing;
